import { render, staticRenderFns } from "./aiPoup.vue?vue&type=template&id=09e24344&scoped=true"
import script from "./aiPoup.vue?vue&type=script&lang=js"
export * from "./aiPoup.vue?vue&type=script&lang=js"
import style0 from "./aiPoup.vue?vue&type=style&index=0&id=09e24344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e24344",
  null
  
)

export default component.exports